import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b9d62ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showCover)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "loading",
      style: _normalizeStyle({ top: _ctx.top + 'px'})
    }, [
      _createElementVNode("div", {
        class: "loading__image",
        style: _normalizeStyle({ height: _ctx.size + 'px', width: _ctx.size + 'px'})
      }, null, 4)
    ], 4)
  ], 64))
}